import { render, staticRenderFns } from "./mergeOrders.vue?vue&type=template&id=bb544074&scoped=true&"
import script from "./mergeOrders.vue?vue&type=script&lang=js&"
export * from "./mergeOrders.vue?vue&type=script&lang=js&"
import style0 from "./mergeOrders.vue?vue&type=style&index=0&id=bb544074&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb544074",
  null
  
)

export default component.exports